import { parseNoteBodySegments } from "../../utils/customerNoteMentions";

type CustomerNoteBodyProps = {
  body: string;
  className?: string;
};

export function CustomerNoteBody({
  body,
  className = "",
}: CustomerNoteBodyProps) {
  const segments = parseNoteBodySegments(body);

  if (segments.length === 0) {
    return <span className={className}>{body}</span>;
  }

  return (
    <span className={className}>
      {segments.map((segment, index) =>
        segment.type === "mention" ? (
          <span
            key={`mention-${segment.userId}-${index}`}
            className="font-medium text-blue-600"
          >
            @{segment.username}
          </span>
        ) : (
          <span key={`text-${index}`}>{segment.value}</span>
        ),
      )}
    </span>
  );
}
